 <template>
  <v-form ref="partnershipEditForm" v-model="valid" class="partnership-page">
    <v-row>
      <v-col cols="12">
        <h1>Сотрудничество</h1>
      </v-col>

      <v-col  cols="12" sm="5" md="4" xl="3">
        <v-img :src="previewImage(true, headerImage)" width="246" height="195" class="mb-8">
          <template v-slot:placeholder>
            <div class="image-placeholder"></div>
          </template>
        </v-img>
        <v-file-input label="Картинка"
                      prepend-icon=""
                      class="cursor-pointer"
                      outlined
                      placeholder="1768х1402"
                      append-icon="mdi-attachment"
                      v-model="headerImage">
        </v-file-input>
            <v-tabs v-model="tabLang">
              <v-tab>RU</v-tab>
              <v-tab>UA</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabLang">
              <v-tab-item :eager="true">
                <v-row>
                  <v-col>
                    <v-text-field
                            v-model="partnership.title"
                            label="Заголовок"
                            outlined
                    ></v-text-field>
                    <v-textarea
                        v-model="partnership.description"
                        label="Описание"
                        outlined
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :eager="true">
                <v-row>
                  <v-col>
                    <v-text-field
                            v-model="partnership.title_ua"
                            label="Заголовок"
                            outlined
                    ></v-text-field>
                    <v-textarea
                        v-model="partnership.description_ua"
                        label="Описание"
                        outlined
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>

        <v-btn @click="update">Сохранить</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import PageService from './../../api/PageService'

  export default {
    name: 'Partnership',
    props: {
    },
    components: {},
    data: () => ({
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      valid: true,
      headerImage: null,
      tab: '',
      tabLang: '',
      partnership: {
          image: null,
          image_url: null
      },
      loading: true,
      loadingButton: false,
    }),
    mounted() {
            PageService.getPartnership()
                .then(response => {
                    this.partnership = response.data;
                    if (this.partnership.image) {
                        this.headerImage = {}
                        this.headerImage.url = this.partnership.image_url;
                        this.headerImage.name = this.partnership.image
                    }
                    this.loading = false
                });
    },
    methods: {
      validate() {


      },
        previewImage(isHeader, image) {
            if (isHeader) {
                if (this.headerImage && this.headerImage.url) {
                    return this.headerImage.url
                }
            } else {
                if (this.footerImage && this.footerImage.url) {
                    return this.footerImage.url
                }
            }

            if (image) {
                return URL.createObjectURL(image)
            }
        },
      update(){

        this.loadingButton = true;
        let formData = this.getData();

        PageService.updatePartnership(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Страница успешно обновлена';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении страницы';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      getData() {
          let formData = new FormData();

          formData.append('title', this.partnership.title);
          formData.append('title_ua', this.partnership.title_ua);
          formData.append('description', this.partnership.description);
          formData.append('description_ua', this.partnership.description_ua);

          if (this.headerImage && !this.headerImage.url) {
              formData.append('headerImage', this.headerImage);
          }

          return formData;
      }
    },
  }
</script>

<style lang="scss">
  .partnership-page{
    .v-input__append-inner{
      margin-top: 13px!important;
    }
  }
</style>

<style scoped lang="scss">
  .partnership-images .v-image{
    max-height: 374px;
  }
  .mobile{
    width: 300px;
    height: 300px;
    margin-bottom: 24px;
  }
  .partnership{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
